import { Card, CardContent, Typography, List, ListItem, ListItemText } from "@mui/material";

interface AnimatedCardProps {
  item: {
    year: string;
    type?: string;
    role: string;
    company: string;
    points?: string[];
  };
}

export default function AnimatedCard({ item }: AnimatedCardProps) {
  return (
    <Card sx={{ minWidth: 250, position: "relative" }}>
      <CardContent>
        <Typography variant="h6">{item.role}</Typography>
        <Typography variant="subtitle2" color="text.secondary">
          {item.company}
        </Typography>

        {item.points && item.points.length > 0 && (
          <List dense>
            {item.points.map((point, i) => (
              <ListItem key={i} sx={{ pl: 0 }}>
                <ListItemText primary={`• ${point}`} />
              </ListItem>
            ))}
          </List>
        )}
      </CardContent>
    </Card>
  );
}
